module.exports = __webpack_public_path__ + "img/grain-logotype.1cdc1e11.png";